import * as React from 'react';
import { useEffect, useState } from 'react';
import { Box, Stack, Button, IconButton } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import { Edit } from '@mui/icons-material';
import BreadCrumb from '../../../common/components/Breadcrumb/index';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
    getAllCategories,
    createCategory,
    editCategoryById,
    deleteCategoryById,
} from '../../../API/Category';
import CategoryDialog from './components/CategoryDialog';
import DeleteConfirmDialog from './components/DeleteConfirmDialog';

const breadCrumb = [
    {
        id: '01',
        breadItem: 'categories',
    },
];

const AdminCategory = () => {
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [data, setData] = useState([]);

    const fetchCategories = () => {
        getAllCategories()
            .then((categories) => setData(categories))
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleEditCategory = (id) => {
        const selected = data.find((c) => c._id === id);
        if (selected) {
            setSelectedCategory(selected);
            setOpen(true);
        }
    };

    const handleDeleteClick = (id) => {
        const selected = data.find((c) => c._id === id);
        if (selected) {
            setSelectedCategory(selected);
            setOpen2(true);
        }
    };

    const handleDialogSubmit = async (values) => {
        if (selectedCategory) {
            // Edit flow
            const response = await editCategoryById(
                selectedCategory._id,
                values,
            );
            if (response.data.success) {
                toast.success('Category Updated successfully');
            }
        } else {
            // Create flow
            const response = await createCategory(values);
            if (response.data.success) {
                toast.success('Category Created successfully');
            }
        }
        setOpen(false);
        setSelectedCategory(null);
        fetchCategories();
    };

    const handleDeleteConfirm = async () => {
        if (!selectedCategory) return;
        try {
            await deleteCategoryById(selectedCategory._id);
            toast.success('Category deleted successfully');
        } catch (err) {
            console.log(err);
            toast.error('Failed to delete category');
        }
        setOpen2(false);
        setSelectedCategory(null);
        fetchCategories();
    };

    const columns = [
        { field: 'categoryCode', headerName: 'Category Code', flex: 2 },
        {
            field: 'categoryName',
            headerName: 'Category Name',
            flex: 2,
        },
        {
            field: 'updatedAt',
            headerName: 'Last Updated',
            flex: 2,
            valueFormatter: (params) => {
                const date = new Date(params.value);
                return date.toLocaleString();
            },
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 1.5,
            sortable: false,
            renderCell: (params) => (
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    height="100%"
                >
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            handleEditCategory(params.row._id);
                        }}
                        aria-label="edit"
                    >
                        <Edit sx={{ fontSize: 20 }} />
                    </IconButton>

                    {/* <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteClick(params.row._id);
                        }}
                        aria-label="delete"
                    >
                        <DeleteIcon sx={{ fontSize: 20, color: 'red' }} />
                    </IconButton> */}
                </Stack>
            ),
        },
    ];

    const navigate = useNavigate();

    return (
        <>
            <Box sx={{ mb: 1.5, mx: { xs: 4, md: 9 } }}>
                <BreadCrumb breadItems={breadCrumb} />
            </Box>

            <Box
                sx={{
                    mx: { xs: 4, md: 9 },
                    display: 'flex',
                    rowGap: 2,
                    alignItems: 'flex-end',
                    flexDirection: 'column',
                }}
            >
                <Button
                    variant="contained"
                    onClick={() => {
                        setSelectedCategory(null);
                        setOpen(true);
                    }}
                    color="secondary"
                >
                    ADD category
                </Button>

                <Box sx={{ height: 500, width: '100%' }}>
                    <DataGrid
                        rows={data}
                        columns={columns}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        getRowId={(row) => row?._id}
                        id={Math.random()}
                        disableSelectionOnClick
                        sx={{
                            '& .MuiDataGrid-row:hover': {
                                cursor: 'pointer',
                            },
                        }}
                        onRowClick={(details) => {
                            navigate('/dashboard/category/subcategory', {
                                state: {
                                    data: 'data',
                                    subCategories: details.row.subCategories,
                                    majorId: details.id,
                                },
                            });
                        }}
                    />
                </Box>
            </Box>

            <CategoryDialog
                open={open}
                onClose={() => {
                    setOpen(false);
                    setSelectedCategory(null);
                }}
                selectedCategory={selectedCategory}
                onSubmit={handleDialogSubmit}
            />

            <DeleteConfirmDialog
                open={open2}
                onClose={() => {
                    setOpen2(false);
                    setSelectedCategory(null);
                }}
                categoryName={selectedCategory?.categoryName || ''}
                onConfirm={handleDeleteConfirm}
            />
        </>
    );
};

export default AdminCategory;
